import { render, staticRenderFns } from "./CarItem.vue?vue&type=template&id=ddac6f1a&scoped=true&"
import script from "./CarItem.vue?vue&type=script&lang=js&"
export * from "./CarItem.vue?vue&type=script&lang=js&"
import style0 from "./CarItem.vue?vue&type=style&index=0&id=ddac6f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac6f1a",
  null
  
)

export default component.exports